/* Krampus redesign — presentation behaviour only (no cart, checkout or form simulation). */
(() => {
  // Mobile navigation dialog.
  const menu = document.getElementById('kh-mobile-menu');
  const toggle = document.querySelector('.kh .menu-toggle');
  if (menu && toggle && typeof menu.showModal === 'function') {
    const close = () => { if (menu.open) menu.close(); };
    toggle.addEventListener('click', () => {
      menu.showModal();
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('kh-menu-open');
    });
    const closeBtn = menu.querySelector('.menu-close');
    if (closeBtn) closeBtn.addEventListener('click', close);
    menu.querySelectorAll('a').forEach((a) => a.addEventListener('click', close));
    menu.addEventListener('close', () => {
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('kh-menu-open');
      toggle.focus();
    });
    menu.addEventListener('click', (e) => {
      if (e.target !== menu) return;
      const r = menu.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close();
    });
    window.matchMedia('(min-width: 901px)').addEventListener('change', (e) => { if (e.matches) close(); });
  }

  // Rotating shipping announcements: prices first, configurable interval, pause control.
  document.querySelectorAll('.kh [data-kh-rotate]').forEach((banner) => {
    const messages = [...banner.querySelectorAll('.announcement-message')];
    if (messages.length < 2) return;
    const pause = banner.querySelector('.announcement-pause');
    const interval = Math.max(3000, parseInt(banner.dataset.khRotate, 10) || 10000);
    let index = 0, paused = false, hovering = false, focused = false;
    if (pause) pause.addEventListener('click', () => {
      paused = !paused;
      pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? 'Resume shipping announcements' : 'Pause shipping announcements');
      pause.textContent = paused ? '▶' : 'Ⅱ';
    });
    banner.addEventListener('mouseenter', () => { hovering = true; });
    banner.addEventListener('mouseleave', () => { hovering = false; });
    banner.addEventListener('focusin', () => { focused = true; });
    banner.addEventListener('focusout', (e) => { if (!banner.contains(e.relatedTarget)) focused = false; });
    window.setInterval(() => {
      if (paused || hovering || focused || document.hidden) return;
      messages[index].classList.remove('is-active');
      messages[index].setAttribute('aria-hidden', 'true');
      index = (index + 1) % messages.length;
      messages[index].classList.add('is-active');
      messages[index].removeAttribute('aria-hidden');
    }, interval);
  });
})();

/* ---- Product pages ---- */
(() => {
  // Gallery: thumbnails swap the stage; the studio bottle view and medal strip show only for the studio image.
  document.querySelectorAll('.kh [data-kh-gallery]').forEach((gallery) => {
    const stage = gallery.querySelector('.product-main-image');
    const buttons = [...gallery.querySelectorAll('.product-thumbnails button')];
    if (!stage || !buttons.length) return;
    let photo = stage.querySelector('.product-photo');
    if (!photo) { photo = document.createElement('img'); photo.className = 'product-photo'; photo.hidden = true; stage.appendChild(photo); }
    buttons.forEach((b) => b.addEventListener('click', () => {
      const studioSrc = stage.dataset.studioSource;
      const isStudio = studioSrc && b.dataset.image === studioSrc;
      const view = stage.querySelector('.studio-bottle-view');
      const medals = gallery.querySelector('.studio-medals');
      if (view) view.hidden = !isStudio;
      if (medals) medals.hidden = !isStudio;
      photo.hidden = !!isStudio;
      if (!isStudio) { photo.src = b.dataset.image; photo.alt = b.dataset.alt || ''; }
      buttons.forEach((x) => { x.classList.toggle('is-selected', x === b); x.setAttribute('aria-pressed', String(x === b)); });
    }));
  });

  // Variant select: update visible price, sold-out state and the URL (the form posts the real variant id).
  document.querySelectorAll('.kh [data-kh-variant-select]').forEach((select) => {
    const root = select.closest('.kh-product');
    const price = root && root.querySelector('[data-kh-price]');
    const button = root && root.querySelector('[data-kh-add]');
    const update = () => {
      const opt = select.selectedOptions[0];
      if (!opt) return;
      if (price) price.textContent = opt.dataset.price;
      let cmp = root.querySelector('[data-kh-compare]');
      if (opt.dataset.compare) {
        if (!cmp) { cmp = document.createElement('s'); cmp.className = 'kh-compare'; cmp.dataset.khCompare = ''; price.after(cmp); }
        cmp.textContent = opt.dataset.compare;
      } else if (cmp) cmp.remove();
      const available = opt.dataset.available === 'true';
      if (button) {
        button.disabled = !available;
        const label = button.querySelector('span');
        if (label) label.textContent = available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', opt.value);
      window.history.replaceState({}, '', url.toString());
    };
    select.addEventListener('change', update);
  });

  // Editorial description: presentation only — the product's own text is never changed.
  document.querySelectorAll('.kh [data-kh-description]').forEach((desc) => {
    const insert = desc.querySelector('[data-kh-desc-insert]');
    if (insert) insert.remove();
    const text = (el) => (el.textContent || '').replace(/\s+/g, ' ').trim();
    // Description-level h1s become h2s so the product title stays the page's only h1.
    desc.querySelectorAll('h1').forEach((h1) => { const h2 = document.createElement('h2'); h2.innerHTML = h1.innerHTML; h1.replaceWith(h2); });
    // Existing inline labels become headings (same wording).
    const labels = ['How to Drink It', 'How to drink it', 'Tasting Notes:', 'Serving:', 'Details:', 'Then there’s the spirit underneath it.', "Then there's the spirit underneath it."];
    [...desc.querySelectorAll('p')].forEach((p) => {
      if (labels.includes(text(p))) { const h = document.createElement('h3'); h.className = 'description-signpost'; h.textContent = text(p); p.replaceWith(h); return; }
      const first = p.firstElementChild;
      if (!first || !/^(STRONG|B)$/.test(first.tagName)) return;
      const label = text(first);
      if (!labels.includes(label)) return;
      if (text(p) === label) { const h = document.createElement('h3'); h.className = 'description-signpost'; h.innerHTML = first.innerHTML; p.replaceWith(h); }
      else { const h = document.createElement('h3'); h.className = 'description-signpost'; h.innerHTML = first.innerHTML; first.remove(); const br = p.firstElementChild; if (br && br.tagName === 'BR') br.remove(); p.before(h); }
    });
    // Short, fully bold opening line becomes the facts panel.
    const firstP = desc.querySelector('p');
    if (firstP && text(firstP).length < 180 && firstP.firstElementChild && /^(STRONG|B)$/.test(firstP.firstElementChild.tagName) && text(firstP.firstElementChild).length > text(firstP).length * 0.8) firstP.classList.add('description-facts');
    // Signposts before paragraphs that start with known phrases.
    (desc.dataset.khSignposts || '').split('||').filter(Boolean).forEach((pair) => {
      const [prefix, label] = pair.split('::');
      const p = [...desc.querySelectorAll('p')].find((x) => text(x).startsWith(prefix));
      if (!p) return;
      const prev = p.previousElementSibling;
      if (prev && /^H[2-4]$/.test(prev.tagName)) return;
      const h = document.createElement('h3'); h.className = 'description-signpost'; h.textContent = label; p.before(h);
    });
    // Place press quote + Nerd Specs before the serving / tasting-flight / awards chapter, else at the end.
    if (insert) {
      const anchor = [...desc.querySelectorAll('h2,h3,h4')].find((x) => /how to drink|serving|tasting flight|how it.s used|^awards$/i.test(text(x)));
      if (anchor) anchor.before(...insert.children); else desc.append(...insert.children);
    }
    // Group each heading after the first with its prose into a chapter with a fine divider.
    const kids = [...desc.children];
    let seenHeading = false, chapter = null;
    kids.forEach((el) => {
      const isHeading = /^H[2-4]$/.test(el.tagName) && !el.closest('.nerd-specs');
      const isBlock = el.classList.contains('nerd-specs') || el.classList.contains('product-press-quote');
      if (isBlock) { chapter = null; return; }
      if (isHeading) {
        if (!seenHeading) { seenHeading = true; chapter = null; return; }
        chapter = document.createElement('div');
        chapter.className = 'description-chapter';
        if (/award/i.test(text(el))) chapter.classList.add('description-awards');
        el.before(chapter);
        chapter.append(el);
        return;
      }
      if (chapter) chapter.append(el);
    });
    desc.classList.add('is-editorial-ready');
  });
})();
